import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const forgotPinAction = createActionGroup({
  source: 'Forgot Pin',
  events: {
    requestForgotPin: emptyProps(),
    requestUserEmail: emptyProps(),
    requestUserEmailSucess: props<{ email: string }>(),
    requestOtp: props<{ email: string }>(),
    requestOtpSuccess: props<{
      email: string;
      otpToken: string;
      resendDelaySeconds?: number;
      twoFactorAuthMethod?: 'OTP' | 'TOTP' | string;
    }>(),
    requestOtpFailed: props<{ error: string }>(),

    requestOtpValidation: props<{ otp: string }>(),
    requestOtpValidationSuccess: props<{ otpToken: string }>(),
    requestOtpValidationFailed: props<{ error: string }>(),
  },
});
